import { Loader } from '@calendly/ui/components/loader'
import { useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useFlag } from '@calendly/feature-check-react'

import LayoutContainer from 'components/layout/container'
import ErrorAlert from 'components/error/alert'
import { ConfirmationPageDataWrapper, useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import { BookingStorage } from 'components/confirmation/booking-storage'
import { ConfirmationPanel, ConfirmationRedesignFooterSection } from 'components/confirmation/layout'
import { PhoneVerificationFeature } from 'components/phone_verification'

import { MeetingPollConfirmation } from './meeting_poll_confirmation'
import { Confirmation as NewConfirmation } from './new_confirmation'
import { ConfirmationPage as OldConfirmation } from './legacy'

const ConfirmationMainPanel = ({ children }) => {
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  return (
    <LayoutContainer
      expanded
      hideBranding={bookingAppRedesign}
      fitContent={bookingAppRedesign}
      stacked={bookingAppRedesign}
    >
      <ConfirmationPanel bookingAppRedesign={bookingAppRedesign}>
        {children}
      </ConfirmationPanel>
      {bookingAppRedesign && <ConfirmationRedesignFooterSection />}
    </LayoutContainer>
  )
}

const CurrentConfirmationPage = () => {
  const { useNewConfirmation } = useConfirmationPageData()

  return (
    <ConfirmationMainPanel>
      {useNewConfirmation ? <NewConfirmation /> : <OldConfirmation />}
    </ConfirmationMainPanel>
  )
}

const ConfirmationPageComponent = () => {
  const history = useHistory()
  const location = useLocation()
  const { event, eventType, isMeetingPollFlow } = useConfirmationPageData()
  const returnPath = useMemo(() => {
    const pathMatch = location.pathname.match(/^(.*)\/invitees\//)
    return pathMatch ? pathMatch[1] : null
  }, [location.pathname])

  useEffect(() => {
    if (!returnPath) return undefined

    const unlisten = history.listen((_, action) => {
      if (action === 'POP') {
        window.location.href = returnPath
      }
    })

    return () => unlisten()
  }, [history, returnPath])
  // ───────────────────────────────────────────

  useEffect(() => { // On all confirmation pages, remove all potential past Stripe redirect stored info
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('pi_')) {
        localStorage.removeItem(key)
      }
    })
  }, [])

  if (eventType === undefined) return <Loader />
  if (event === undefined) return <Loader />
  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }
  if (isMeetingPollFlow) {
    return (
      <ConfirmationMainPanel>
        <MeetingPollConfirmation />
      </ConfirmationMainPanel>
    )
  }
  return <CurrentConfirmationPage />
}

export const ConfirmationPage = () => (
  <ConfirmationPageDataWrapper>
    <ConfirmationPageComponent />
    <PhoneVerificationFeature />
    <BookingStorage />
  </ConfirmationPageDataWrapper>
)
